import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16311c16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modalContent",
  class: "px-6"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " - Hold \"Shift\" key and mark parking spots which you want edit "),
    /*#__PURE__*/_createElementVNode("li", null, " - Hold \"Ctrl\" key and click on first then on last parking spot which you want edit "),
    /*#__PURE__*/_createElementVNode("li", null, " - Unselect parking spots with \"Space\" key "),
    /*#__PURE__*/_createElementVNode("li", null, " - \"Recalculate names\" button will be calculate new parking spot names "),
    /*#__PURE__*/_createElementVNode("li", null, " - If you have different segments of parking spot names, mark spots, give start number and after all, recalculate for these marked parking spots "),
    /*#__PURE__*/_createElementVNode("li", null, " - \"Move to parking space position\" button will be move parking spots to location of parking space ")
  ])
], -1))
const _hoisted_3 = { class: "flex items-center justify-end py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isInfoModalOpened,
    "no-padding": true,
    title: "Info",
    onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            "button-type": "oulineButton",
            text: "Close",
            onExecuteMethod: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-modal')))
          })
        ])
      ], 512)
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}